import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";
import { steps } from "@/constants/LandingSection";
import useAuthStore from "@/shared/zustand/authStore";
export const LandingSectionStepper = ({ activeStep, }) => {
    const stepKeys = steps.map((step) => Object.keys(step)[0]); // Extract step names (keys)
    const activeIndex = stepKeys.indexOf(activeStep); // Find the index of activeStep
    return (_jsx("div", { className: "grid grid-cols-3 gap-x-2", children: steps.map((step, index) => {
            const stepKey = Object.keys(step)[0]; // Extract step key
            const stepLabel = step[stepKey]; // Get step label safely
            return (_jsxs("div", { className: `${activeIndex === index
                    ? "text-[#2546F0]" // Active step text color
                    : activeIndex > index
                        ? "text-[#2546F0]" // Completed step text color
                        : "text-[#9CA3AF]" // Upcoming step text color
                } text-sm flex flex-col gap-y-1`, children: [_jsx("div", { className: `h-1 rounded-full w-full ${activeIndex === index
                            ? "bg-[#2546F0]" // Active step bar color
                            : activeIndex > index
                                ? "bg-[#2546F0]" // Completed step bar color
                                : "bg-[#E5E7EB]" // Upcoming step bar color
                        }` }), _jsx("span", { className: "font-normal", children: stepLabel })] }, stepKey));
        }) }));
};
const LandingSection = ({ addModeToHistory, 
// activeStep,
// setActiveStep,
setStreamingMessages, isUserOnboarded, setIsUserOnboarded, }) => {
    const { onboardingStep } = useAuthStore();
    // const handleNext = () => {
    //   setActiveStep((prev) => prev + 1);
    // };
    // const handleBack = () => {
    //   setActiveStep((prev) => prev - 1);
    // };
    return (_jsxs("div", { className: "w-full h-full flex flex-col justify-between font-content gap-y-8", children: [onboardingStep === "personas" && (_jsx(StepOne
            // handleNext={handleNext}
            // activeStep={activeStep}
            , {})), onboardingStep === "data sources" && (_jsx(StepTwo
            // handleNext={handleNext}
            // handleBack={handleBack}
            // activeStep={activeStep}
            , {})), onboardingStep === "done" && (_jsx(StepThree
            // handleBack={handleBack}
            // activeStep={activeStep}
            , { 
                // handleBack={handleBack}
                // activeStep={activeStep}
                addModeToHistory: addModeToHistory, 
                // setCurrentHostMode={setCurrentHostMode}
                setStreamingMessages: setStreamingMessages, isUserOnboarded: isUserOnboarded, setIsUserOnboarded: setIsUserOnboarded }))] }));
};
export default LandingSection;
